export default {
delta360_endpoint: 'https://greenqueen.api.intm.cc/api/', 
// delta360_endpoint: 'http://unitsv8.test/api/',
}